import {Component, OnInit, OnChanges, Output, EventEmitter, Input} from '@angular/core';
import {WizardWidgetComponent} from '../wizard-widget/wizard-widget.component';
import {FormBuilderService} from '../../../services';
import {InvidualInsuranceModel} from '../../../models/widgets/single-split-loan-amount-model';
import {DataHandlerService} from '../../../services/data-handler.service';
import * as _ from 'lodash';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgFor, NgIf } from '@angular/common';

@Component({
    selector: 'app-insurance',
    templateUrl: './insurance-details.component.html',
    styles: [],
    standalone: true,
    imports: [NgFor, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatFormFieldModule, MatSelectModule, MatSelectModule, MatOptionModule, MatOptionModule, MatInputModule, MatInputModule, MatButtonModule, MatButtonModule, MatIconModule, NgIf]
})
export class InsuranceDetailsComponent extends WizardWidgetComponent implements OnInit, OnChanges {
  @Input() public insurancesFormArray: any;
  @Input() public insuranceList: any;
  @Output() public totalInsuranceAmountChange = new EventEmitter<any>();

  public allInsurances = [];

  constructor(public dataHandlerService: DataHandlerService,
              private formBuilderService: FormBuilderService) {
    super(dataHandlerService);
  }

  ngOnInit() {
  }

  ngOnChanges(changes) {
    if (changes['insuranceList']) {
      const insuranceListData = changes['insuranceList']['currentValue']
      this.allInsurances = _.uniqWith(insuranceListData, _.isEqual) ;
      this.processInsurances();
    }
  }

  public addInsurance(index) {
    const fg = this.formBuilderService.convertObjectToFormGroup(new InvidualInsuranceModel());
    this.formBuilderService.setValidationRules(new InvidualInsuranceModel(), fg);
    this.insurancesFormArray.push(fg);
  }

  public removeInsurance(index) {
    this.insurancesFormArray.removeAt(index);
    // always keep 1
    if (this.insurancesFormArray.controls.length === 0) {
      this.addInsurance(0);
    }
    this.processInsurances();
  }

  public processInsurances() {
    let total = 0;
    this.insurancesFormArray.controls.forEach((insurance, i) => {
      if (insurance.value.insuranceAmount && !insurance.value.insuranceId) {
        // check insurance name, if amount is given
        this.insurancesFormArray.controls[i].get('insuranceId').setErrors({invalid: true});
      } else if (insurance.value.insuranceId && insurance.value.insuranceAmount < 1) {
        // check amount, if insurance is selected
        this.insurancesFormArray.controls[i].get('insuranceAmount').setErrors({invalid: true});
      } else {
        total += parseInt(insurance.value.insuranceAmount, 10);
      }
    });
    this.totalInsuranceAmountChange.emit(total);
  }
}
